export default __webpack_public_path__ + "static/stickers_phonesmartPrize-07b552dba9c6918914a70a4a34e035d5.png";